<template>
  <div>
    <PageAllow controller="Foods" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet v-show="!currentItemMode" class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="dishKeyword = $event"
              :label="$t('Dish.dishesKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('FoodBehavior', 'index')"
              small
              color="primary"
              @click.stop="$router.push('/dishes/cooking-methods/')"
              class="ms-1"
            >
              {{ $t("CookingMethods.title") }}
            </v-btn>
            <v-btn
              v-if="
                settings &&
                settings.push_platform != 1018 &&
                settings.push_platform <= 2000 &&
                !sync_material_data_from && // 有三方对接但基础信息以本地录入形式处理
                $permission.permissionAllow('Foods', 'add')
              "
              small
              color="primary"
              @click.stop="
                currentItemMode = 'new';
                currentItem = { id: 0 };
              "
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("Dish.ObjectName")]) }}
            </v-btn>
            <v-btn
              v-if="
                settings &&
                (settings.push_platform == 1018 ||
                  settings.push_platform > 2000 ||
                  sync_material_data_from) &&
                $permission.permissionAllow('Foods', 'add')
              "
              small
              dark
              color="warning"
              class="ms-1"
              @click.stop="syncKingdeeMaterials()"
            >
              <v-icon x-small class="pe-1">fa-sync</v-icon>
              {{ $t("Dish.actions.syncWithKingdee") }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Foods', 'import')"
              small
              color="print"
              dark
              @click.stop="ImportDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-import</v-icon>
              {{ $t("Import.import", [$t("Dish.ObjectName")]) }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('Foods', 'export')"
              small
              color="print"
              dark
              @click.stop="exportExcel()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-file-export</v-icon>
              {{ $t("Export.export", [$t("Dish.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherDishCategory v-model="dishCategorySelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherCookingMethod v-model="cookingMethodSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherRecipes v-model="dishRecipesSelected" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="dishes"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1"
          fixed-header
          :footer-props="$t('$config.footer-props')"
          mobile-breakpoint="800"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.food_code="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            <v-avatar
              tile
              color="bgGrey"
              style="vertical-align: top"
              class="my-1"
            >
              <v-menu open-on-hover :key="item.food_img_url">
                <template v-slot:activator="{ on, attrs }">
                  <v-img
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.food_img_url"
                    alt="Avatar"
                    :src="item.food_img_url + '?x-image-process=style/160x160'"
                  />
                </template>
                <v-img :src="item.food_img_url" width="160" />
              </v-menu>
            </v-avatar>
            <div class="d-inline-block ma-1">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="d-block text-truncate"
                    style="max-width: 430px; cursor: pointer"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >{{ item.food_name }}
                  </span>
                </template>
                {{ item.food_name }}
              </v-tooltip>
              <span class="caption secondary--text">
                {{ item.food_code }}
              </span>
            </div>
          </template>
          <template v-slot:item.price="{ item }">
            {{ $t("Global.money") }}{{ item.price | formatMoney }}
          </template>
          <template v-slot:item.cooking_method_str="{ item }">
            <v-menu
              open-on-hover
              right
              offset-x
              class="text-center"
              :close-on-content-click="false"
              v-if="item.food_relations.length > 1"
              close-delay="100"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ item.cooking_method_str }} <br />
                  <span class="caption secondary--text">
                    {{ item.cooking_method_code }}
                  </span></span
                >
              </template>
              <v-list>
                <v-list-item
                  v-for="(relation, i) in item.food_relations"
                  :key="i"
                >
                  {{ relation.food_behavior.behavior_name }} /
                  {{ relation.food_behavior.behavior_code }}
                </v-list-item>
              </v-list>
            </v-menu>
            <span v-else>
              {{ item.cooking_method_str }} <br />
              <span class="caption secondary--text">
                {{ item.cooking_method_code }}
              </span>
            </span>
          </template>
          <template v-slot:item.cost="{ item }">
            {{ $t("Global.money") }}{{ item.cost | formatMoney }}
          </template>
          <template v-slot:item.cost_rate="{ item }">
            {{ item.cost_rate | formatTwoDot }}{{ $t("Global.rate") }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="$permission.permissionAllow('Foods', 'view')">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  class="px-1 me-1"
                  @click.stop="
                    currentItemMode = 'view';
                    currentItem = item;
                  "
                  >fa-file-alt
                </v-icon>
              </template>
              <span>{{ $t("CRUD.viewInfo", [$t("Dish.ObjectName")]) }}</span>
            </v-tooltip>
            <v-tooltip top v-if="$permission.permissionAllow('Foods', 'edit')">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    currentItemMode = 'edit';
                    currentItem = item;
                  "
                  >fa-pencil-alt
                </v-icon>
              </template>
              <span>{{ $t("CRUD.editInfo", [$t("Dish.ObjectName")]) }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Foods', 'delete')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="danger"
                  class="px-1 me-1"
                  @click.stop="
                    currentItem = item;
                    deleteDialog = true;
                  "
                  >fa-trash-alt
                </v-icon>
              </template>
              <span>{{ $t("CRUD.deleteInfo", [$t("Dish.ObjectName")]) }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>

      <DialogDelete
        v-model="deleteDialog"
        :label="$t('Dish.ObjectName')"
        @confirm="
          del();
          deleteDialog = false;
        "
      />
    </v-sheet>
    <DishDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      @save="getDishesFromAPI()"
    />

    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('Dish.ObjectName')"
      downloadTemplateUrl="download/template/foods_template.xlsx"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDishCategory from "@/components/plugins/SearcherDishCategory";
import SearcherCookingMethod from "@/components/plugins/SearcherCookingMethod";
import DialogDelete from "@/components/plugins/DialogDelete";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import DishDetail from "./plugins/Detail";
import Dishes from "@/api/dishes";
import KingdeeWorker from "@/api/kingdee_worker";
import YywdMiddleware from "@/api/yywd_middleware";
import YywdNewMiddleware from "@/api/yywd_new_middleware";
import SearcherRecipes from "@/components/plugins/SearcherRecipes";

const defaultOptions = {
  keyword: "",
  food_category_id: "",
  food_behavior_id: "",
  formula_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherDishCategory,
    SearcherCookingMethod,
    ImportExcelAlert,
    DishDetail,
    DialogDelete,
    SearcherRecipes,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.dishManagement"),
        disabled: false,
        href: "/dishes",
      },
      {
        text: i18n.t("Nav.dishes"),
        disabled: true,
        href: "/dishes",
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("Dish.Fields.dish"),
          align: "start",
          sortable: true,
          value: "food_code",
        },
        // {
        //   text: i18n.t("Dish.Fields.dish_name"),
        //   align: "start",
        //   sortable: false,
        //   value: "food_name",
        // },
        {
          text: i18n.t("Dish.Fields.dish_category"),
          align: "end",
          class: "text-no-wrap",
          sortable: false,
          value: "food_category.name",
        },
        {
          text: i18n.t("Dish.Fields.dish_unit"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("Dish.Fields.sell_price"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("Dish.Fields.cost_price"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "cost",
        },
        {
          text: i18n.t("Dish.Fields.gross_profit_rate"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "cost_rate",
        },
        {
          text: i18n.t("Dish.Fields.dish_practice"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "cooking_method_str",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "sync_material_data_from"]),
  },

  data: () => ({
    dishCategorySelected: null,
    cookingMethodSelected: null,
    dishKeyword: "",
    options: JSON.parse(
      sessionStorage.getItem("dishes-options")
        ? sessionStorage.getItem("dishes-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    dishes: [],
    currentItem: null,
    currentItemMode: null,
    deleteDialog: false,
    ImportDialog: false,
    excelFile: null,
    importDishesResultFlg: false,
    importDishesResult: [],
    dishRecipesSelected: [],
  }),

  mounted() {
    if (this.$route.query.mode && this.$route.query.id) {
      this.currentItem = { id: this.$route.query.id };
      this.currentItemMode = this.$route.query.mode;
    }
    this.$commonUtils
      .loadOptions("dishes", [
        "dishCategorySelected",
        "cookingMethodSelected",
        "dishRecipesSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "dishCategorySelected":
                this.dishCategorySelected = selected.value;
                break;
              case "cookingMethodSelected":
                this.cookingMethodSelected = selected.value;
                break;
              case "dishRecipesSelected":
                this.dishRecipesSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.dishCategorySelected = null;
      this.cookingMethodSelected = null;
      this.dishRecipesSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.dishKeyword,
      });
    },
    getDishesFromAPI() {
      Dishes.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.dishes = response.data.foods.map((food) => {
              let cookingMethodStr = "";
              let cookingMethodCode = "";
              if (
                food.food_relations[0] &&
                food.food_relations[0].food_behavior
              ) {
                cookingMethodStr +=
                  food.food_relations.length > 1
                    ? food.food_relations[0].food_behavior.behavior_name +
                      "，... ..."
                    : food.food_relations[0].food_behavior.behavior_name;
                cookingMethodCode +=
                  food.food_relations.length > 1
                    ? food.food_relations[0].food_behavior.behavior_code +
                      "，... ..."
                    : food.food_relations[0].food_behavior.behavior_code;
              }
              food.cooking_method_str = cookingMethodStr;
              food.cooking_method_code = cookingMethodCode;
              return food;
            });
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    del() {
      Dishes.del(this.currentItem.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getDishesFromAPI();
          }
        }.bind(this)
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Dishes.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.ImportDialog = false;
                this.importDishesResultFlg = true;
                this.importDishesResult = response.data.data;
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("Dish.ObjectName")])
                );
                this.ImportDialog = false;
                this.getDishesFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncKingdeeMaterials() {
      this.$store.dispatch("fullscreenLoading");
      if (this.settings.push_platform == 1018)
        KingdeeWorker.addJob({
          event: "sync_materials",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Dish.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      else if (this.sync_material_data_from > 0) {
        var ev = null;
        switch (this.sync_material_data_from) {
          case 1: // 金蝶
            ev = "sync_kingdee_materials";
            break;
        }
        if (ev == null) return; //万一有配置错误就不推送任务了
        YywdNewMiddleware.addJob({
          event: ev,
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Material.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      } else
        YywdMiddleware.addJob({
          event: "sync_materials",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Dish.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    exportExcel() {
      Dishes.foodsExport(this.options);
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/dishes?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/dishes");
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getDishesFromAPI();
        sessionStorage.setItem("dishes-options", JSON.stringify(this.options));
      },
    },
    dishCategorySelected: {
      handler() {
        this.options.food_category_id = this.dishCategorySelected
          ? this.dishCategorySelected.id
          : "";
        sessionStorage.setItem(
          "dishes-dishCategorySelected",
          JSON.stringify(this.dishCategorySelected)
        );
      },
    },
    cookingMethodSelected: {
      handler() {
        this.options.food_behavior_id = this.cookingMethodSelected
          ? this.cookingMethodSelected.id
          : "";
        sessionStorage.setItem(
          "dishes-cookingMethodSelected",
          JSON.stringify(this.cookingMethodSelected)
        );
      },
    },
    dishRecipesSelected: {
      handler() {
        this.options.formula_ids = this.dishRecipesSelected
          ? this.dishRecipesSelected.map((recipe) => {
              return recipe.id;
            })
          : "";
        sessionStorage.setItem(
          "dishes-dishRecipesSelected",
          JSON.stringify(this.dishRecipesSelected)
        );
      },
    },
  },
};
</script>